export class Foto {
    idCliente: number;
    foto: any

    constructor(){
        
    }
}
